import { Component } from '@angular/core';

@Component({
  selector: 'app-register-page-pending',
  imports: [],
  templateUrl: './register-page-pending.component.html',
  styleUrl: './register-page-pending.component.scss'
})
export class RegisterPagePendingComponent {

}
